import { createSlice } from '@reduxjs/toolkit'
import { createAxiosThunk } from 'utils/reduxUtil'
import api from 'api/axios/foka'
import { DOMAIN_TYPE } from 'features/bulk/BulkCodes'
import { CHECKED_LIMIT } from 'features/bulk/download/DownloadTable'
import { BizChannelTypes, CampaignTypes } from '../../Codes'

export const createDownload = createAxiosThunk(
  'bulk/createDownload',
  (name, { getState }) => {
    const { domainType, ids, zipped } = getState().bulk.downloadModal
    return domainType === DOMAIN_TYPE.CAMPAIGN.name
      ? api.bulk.postCampaignDownload({
          name,
          ids,
          zipped,
        })
      : api.bulk.postCreativeDownload({
          name,
          ids,
        })
  }
)

export const fetchTableContent = createAxiosThunk(
  'bulk/fetchTableContent',
  (noArgs, { getState }) => {
    const { domainType } = getState().bulk.downloadModal
    return domainType === DOMAIN_TYPE.CAMPAIGN.name
      ? api.ad.getNotDeletedCampaigns()
      : api.ad.getBizChannels()
  }
)

const initialState = {
  isShow: false,
  isLoading: false,
  disabled: false,
  domainType: DOMAIN_TYPE.CAMPAIGN.name,
  ids: [],
  campaigns: [],
  bizChannels: [],
  zipped: false,
}

const downloadModalSlice = createSlice({
  name: 'bulk/downloadModal',
  initialState,

  reducers: {
    showDownloadModal: state => {
      state.isShow = true
    },
    hideDownloadModal: () => initialState,
    setDomainType: (state, { payload }) => {
      state.ids = []
      state.domainType = payload
    },
    addId: (state, { payload }) => {
      state.ids.push(payload)
    },
    removeId: (state, { payload }) => {
      const index = state.ids.indexOf(payload)
      if (index !== -1) state.ids.splice(index, 1)
    },
    checkAll: state => {
      const source =
        state.domainType === DOMAIN_TYPE.CAMPAIGN.name
          ? state.campaigns
          : state.bizChannels
      state.ids = source.slice(0, CHECKED_LIMIT).map(({ id }) => id)
    },
    clearId: state => {
      state.ids = []
    },
    setZipped: (state, { payload }) => {
      state.zipped = payload
    },
  },

  extraReducers: builder => {
    builder.addCase(createDownload.pending, state => {
      state.disabled = true
    })

    builder.addCase(createDownload.fulfilled, state => {
      state.disabled = false
    })

    builder.addCase(createDownload.rejected, state => {
      state.disabled = false
    })

    builder.addCase(fetchTableContent.pending, state => {
      state.ids = []
      state.isLoading = true
    })

    builder.addCase(
      fetchTableContent.fulfilled,
      (state, { payload: { campaigns, content } }) => {
        if (state.domainType === DOMAIN_TYPE.CAMPAIGN.name) {
          state.campaigns = campaigns.filter(
            ({ campaignType }) => campaignType !== CampaignTypes.TALK_CHANNEL
          )
        } else {
          state.bizChannels = content.filter(
            ({ bizChannelType }) =>
              bizChannelType !== BizChannelTypes.TALK_CHANNEL
          )
        }
        state.isLoading = false
      }
    )

    builder.addCase(fetchTableContent.rejected, state => {
      if (state.domainType === DOMAIN_TYPE.CAMPAIGN.name) {
        state.campaigns = []
      } else {
        state.bizChannels = []
      }
      state.isLoading = false
    })
  },
})

const { actions, reducer } = downloadModalSlice
export const {
  showDownloadModal,
  hideDownloadModal,
  setDomainType,
  setZipped,
  addId,
  removeId,
  checkAll,
  clearId,
} = actions
export default reducer
